export default __webpack_public_path__ + "static/media/pdf.1971324a.svg";